import { render, staticRenderFns } from "./FormIdentification.vue?vue&type=template&id=bb30fc7e&scoped=true&"
import script from "./FormIdentification.vue?vue&type=script&lang=js&"
export * from "./FormIdentification.vue?vue&type=script&lang=js&"
import style0 from "./FormIdentification.vue?vue&type=style&index=0&id=bb30fc7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb30fc7e",
  null
  
)

export default component.exports